import { render, staticRenderFns } from "./Table-Search.vue?vue&type=template&id=0dc0c963&"
import script from "./Table-Search.vue?vue&type=script&lang=js&"
export * from "./Table-Search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports